// Import our custom CSS
import '../scss/style.scss'
//import '../scss/menu.scss' 

import "bootstrap-icons/font/bootstrap-icons.scss"
// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

//mask 
//import $ from 'jquery';

import Inputmask from "inputmask";
const inputs = document.querySelectorAll(".masked-input");
const buttons = document.querySelectorAll(".submit-button");

// Применяем маску и обработчик для каждого поля
inputs.forEach((selector, index) => {
  const button = buttons[index];
  const im2 = new Inputmask("+7(999)-999-9999");

  if (selector) {
    im2.mask(selector);

    // Обработчик события для проверки валидности ввода
    selector.addEventListener("input", function () {
      // Получаем текущее значение поля
      const inputValue = selector.value;

      // Проверяем количество введённых цифр (игнорируем маску)
      const digits = inputValue.replace(/\D/g, ''); // Убираем все нецифровые символы

      // Проверяем, введено ли достаточно цифр для завершения ввода
      if (digits.length === 11) { // 10 цифр для полного номера
        button.disabled = false; // Разблокировать кнопку
      } else {
        button.disabled = true; // Заблокировать кнопку
      }
    });
  }
});

 
//mask 

let lastScrollTop = 0;
const menu = document.getElementById('menu-fix');

window.addEventListener("scroll", function(){
   let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
   //console.log(scrollTop);
   if (scrollTop > lastScrollTop){ // скроллим вниз
      menu.style.top = "-150px"; // скрываем меню
   } else { // скроллим вверх
      menu.style.top = "0"; // показываем меню
   }
   if(scrollTop>200){
    menu.classList.add('menu_bg'); 
   }else{
      menu.classList.remove('menu_bg'); 
   }
   lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Для Mobile Safari
}, false);
